module.exports = __webpack_public_path__ + "static/media/scilogex-favicon.3a3836b4.ico";